export default __webpack_public_path__ + "static/media/action-cam-3.eff70fd6.png";